import { BaseService } from "./BaseService";

export interface CacheRefreshStatus {
  Enabled: boolean;
  PublishedPageCount: number;
  Pending: number;
  Failed: number;
  LastCompletedUtc: string | null;
  Active: boolean;
}

export interface CacheRefreshAccepted {
  JobId: number;
  Status: string;
  PublishedPageCount: number;
  Message: string;
}

export class CacheRefreshService extends BaseService {
  public status = (siteId: string) => this._ajaxService.Get<CacheRefreshStatus>(`/Cache/Status/${siteId}`, true, undefined, undefined, true);
  public refresh = (siteId: string) => this._ajaxService.Post<CacheRefreshAccepted>(`/Cache/RefreshSite/${siteId}`, {}, true);
}

export const canRefreshPublishedPages = (status: CacheRefreshStatus | null, submitting: boolean): boolean =>
  !!status?.Enabled && status.PublishedPageCount > 0 && status.Pending === 0 && !submitting;
